import { SpatialCoord } from './../Pixospatial';
import { SnapLayerAPIService } from './../api-services/snap-layer-api.service';
import { GeoJSONObject, Geometry, GeometryObject } from '@turf/turf';
import { Feature, IFeatureContext } from './Feature';
import { PixoSpatial, PixoSpatialCoord } from '../Pixospatial';
import { EventEmitter, Injectable, inject, } from '@angular/core';
import { Dict } from 'src/app/types/decorable';
import { SubScriptionMgr } from '../SubscriptionMgr';
import { MapService } from 'src/app/services/map.service';
import { UUID } from 'angular2-uuid';
import { ISLMap } from 'src/app/types/@types/sl-map';
import { InterruptableTimer } from '../interruptabletimer';
import * as d3 from 'd3';
import { ROICorners } from 'src/app/components/draw-pane/rectangle-roi';
export class SnapPts extends Feature {
  get type(): string {
    return 'snap-points';
  }
  private snapSelections: Array<string> = [];
  private snapLayerAPI: SnapLayerAPIService;
  public points: Array<any> = [];
  public groupMode: boolean = false;
  public get geometryCount(): number {
    length = this.points.length;
    return length;
  }
  public entered: Array<string> = [];
  public enteredChange = new EventEmitter<any>();
  public snapDown = new EventEmitter<void>();
  public map: ISLMap;
  protected localContext: IFeatureContext = { updateHandler: (feature: Feature) => { } };
  private timer = new InterruptableTimer(500);
  private vis: boolean = true;
  private subscriptions = new SubScriptionMgr();
  public geometryLoad = new EventEmitter<void>();
  constructor(
    context: IFeatureContext,
    spatialContext: PixoSpatial = null
  ) {
    super(context, spatialContext);
    this.snapLayerAPI = MapService.Get().snapLayerService;
    this.snapLayerAPI.AddLoadListener(this.id, (value: SnapLayerAPIService) => {
      if (!this.map) {
        this.map = MapService.Get();
        this.map.ui.on('render', () => {
          this.ContextChanged();
        });
        this.map.ui.on('idle', () => {
          this.ContextChanged();
          return;
          this.timer.Start(() => {
            this.Redraw();
          })
        })
      }
      this.geometryLoad.emit();
      this.Redraw();
    });

  }


  Redraw() {
    this.Clear();
    const snapPts = this.snapLayerAPI.GetSnapPoints();
    for (const snapPt of snapPts) {
      this.AddSnapPt(snapPt);
    }
  }

  MakeVertex(points: Array<any>, ptGroup: any, ptInfo: PixoSpatialCoord): any {
    const pt: any = {};
    pt.type = 'snap-point';
    pt.id = this.GenerateId();
    pt.x = ptInfo.pixo.x;
    pt.y = ptInfo.pixo.y;
    pt.coord = ptInfo;
    pt.updateUI = () => {
      const oldX = pt.ui.attr('cx');
      const oldY = pt.ui.attr('cy');

      pt.ui.attr('cx', pt.coord.pixo.x);
      pt.ui.attr('cy', pt.coord.pixo.y);
      this.PointUpdated(pt, oldX, oldY);
    };
    /*if (this.spatialContext !== null) {
      const coord = this.spatialContext.PixoPt(pt);
      pt.coord = this.spatialContext.PixoSpatialCoord(coord);
      pt.coord.PostConvert = () => {
        pt.x = pt.coord.pixo.x;
        pt.y = pt.coord.pixo.y;
        pt.updateUI();
      };
    }*/
    pt.featureId = this.id;
    pt.index = points.length;
    pt.segments = [];
    pt.ui = ptGroup.append('circle');
    pt.ui.attr('cx', pt.x);
    pt.ui.attr('cy', pt.y);
    pt.ui.attr('r', 8);
    pt.ui.classed('point', true);
    pt.ui.classed('snap-point', true);
    pt.ui.attr('data-guid', pt.id);
    // point drag events implemented in base class are not used
    this.lookup[pt.id] = pt;
    pt.ui.on('mousedown', (event) => {
      if (d3.event.cancelable === true) {
        d3.event.preventDefault();
      }
      this.snapDown.emit();
      this.Select(pt.id);

    });
    pt.ui.on('mouseenter', (event) => {
      if ((d3.event.buttons & 1) !== 0) {
        this.enteredChange.emit(pt);
      }
    })
    pt.endInteraction = () => {
      pt.ui.on('mousemove', null);
      pt.ui.on('mousenter', null);
    }
    pt.remove = (uiOnly: boolean) => {
      pt.endInteraction();
      pt.ui.on('mousedown', null);
      pt.ui.remove();
      if (!uiOnly) {
        delete this.lookup[pt.id];
        const ptI = points.indexOf(pt);
        if (ptI > -1) {
          points.splice(ptI, 1);
        }
      }
      this.UpdateContextHandler();
      return pt;
    };
    points.push(pt);
    this.lookup[pt.id] = pt;
    this.vertices = points.length;
    this.UpdateContextHandler();
    return pt;
  }
  private _active: boolean = false;
  SetActive(isActive: boolean) {
    this._active = isActive;
    this.context.snapPt.attr('data-active', isActive ? 'true' : 'false');
  }
  RemoveSelected() {
    if (this.lastSelection.length === 0) {
      return;
    }
    for (const lastSelection of this.lastSelection) {
      const item = this.lookup[this.lastSelection];

      if (item.type === 'segment') {
        const points = [item.from, item.to];
        this.Select(points[1].id);
        this.RemoveSelected();
        this.Select(points[0].id);
        this.RemoveSelected();
        this.geometryChange.emit(this);
        return;
      }
      item.remove();
      this.PointRemoved(item);
    }
    this.snapSelections = [];


  }
  PointRemoved(pt) {
    // extend Feature and override me as needed;
    this.UpdateContextHandler();
  }
  PointUpdated(pt: any, oldX: number, oldY: number) {
    // extend Feature and override me as needed;
    this.UpdateContextHandler();
  }
  VertexAddedTo(pt, seg) {
    this.UpdateContextHandler();
    this.Select(pt.id);
  }
  RemovePoints(points) {
    for (const pt of points) {
      pt.remove();
    }

    this.lookup = {};
    this.snapSelections = [];
    delete this.context;
    for (const group of this.groups) {
      group.remove();
    }
    this.groups = [];
    this.UpdateContextHandler()

  }


  public GetGeometry(): Array<any> {
    const geometry = [];
    const segments = 'segments';
    for (const point of this.points) {
      geometry.push(point);

    }
    return geometry;
  }

  ToGeoJSONGeom(): GeometryObject | false {
    return false; // override me;
  }
  FromGeoJSONGeom(_1geom: Geometry): void {
    return;
  }
  AddSnapPt(ptInfo: any, xProp?: string, yProp?: string): void {
    const spatialCoord = this.spatialContext.PixoSpatialCoord(this.spatialContext.SpatialCoord(ptInfo));
    this.MakeVertex(this.points, this.context.snapPt, spatialCoord)

  }
  HasSnapPt(targetId: string): boolean {
    return (this.lookup.hasOwnProperty(targetId) !== false);
  }
  Deselect(targetId?: string): void {
    if (!targetId) {
      for (let i = this.snapSelections.length - 1; i >= 0; i--) {
        const selection = this.snapSelections[i];
        this.Deselect(selection);
      }
      return;
    }
    const selection = this.lookup[targetId];
    if (!!selection) {
      selection.ui.attr('data-selected', 'false');
      const offset = this.snapSelections.indexOf(targetId);
      this.snapSelections.splice(offset, 1);
    }
  }
  Select(targetId: string): void {
    if (this.groupMode === false) {
      this.Deselect();
      // this.snapSelections.splice(0, this.snapSelections.length);
    }
    if (!this._active) return;
    if (!this.HasSnapPt(targetId)) {
      return;
    }

    if (this.groupMode === true) {
      this.snapSelections.push(targetId);
      this.selectionChange.emit({ source: this, selections: this.snapSelections.splice(0) });
    } else {
      this.snapSelections[0] = targetId;
      this.selectionChange.emit({ source: this, selectedId: targetId, });
    }
    this.lookup[targetId].ui.attr('data-selected', 'true');
  }
  ContextChanged() {
    if (this.spatialContext === null) { return; }
    for (const pt of this.points) {
      (pt.coord as PixoSpatialCoord).UpdateSpatial(pt.coord.spatial.lng, pt.coord.spatial.lat);
      pt.x = pt.coord.pixo.x;
      pt.y = pt.coord.pixo.y;
      pt.updateUI();

    }
    this.UpdateContextHandler();


  }
  public GetSelectedInfo(): Array<any> {
    if (!this.snapSelections) {
      return undefined;
    }
    const pts: Array<any> = [];
    for (const selection of this.snapSelections) {
      pts.push(this.lookup[selection]);
    }
    return pts;
  }
  Clear() {
    this.points.every((point) => {
      if (!!point.remove) {
        point.remove(true);
      }
      return true;
    });
    this.points = [];
    this.lookup = [];
  }
  ToggleVis(isOn?: boolean) {
    if (isOn === undefined) isOn = !this.vis;
    this.vis = isOn;
    this.UpdateVis();
  }
  SetOpacity(val: number) {
    this.context.snapPt.node().style.setProperty('opacity', val)
  }
  UpdateVis() {
    this.context.snapPt.attr('data-hidden', (this.vis ? 'false' : 'true'));
  }




}
